export default {
    container: {
        overflow: 'hidden',
        position: 'relative',
        display: 'flex'
    },
    img: {
        flexShrink: 0
    }
}



// WEBPACK FOOTER //
// ./src/components/Carousel/styles.js